export default __webpack_public_path__ + "static/media/feature2.efabbbef.svg";